import React from 'react'
import css from './style.scss'
import Button from 'components/shared/button'

export default (props)=>{
  let avatar="url("+(props.avatar || "/assets/logo/big.png")+")"
  return (
    <div className={css.emptyPage}>
      <div className={css.avatar} style={{backgroundImage:avatar}} alt="avatar" />
      <div className={css.title}>Welcome {props.name ? props.name : "my friend"}!</div>
      <p>
        Thank you for giving <b>Stori</b> a try.
        <br/>
        Are you ready to add your first Instagram account?
      </p>
      <Button to={"/accounts/new"} className={css.newAccountButton} primary>Add your first account</Button>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/accounts_page/empty.js